import { render, staticRenderFns } from "./AccUpdatePersonalData.vue?vue&type=template&id=5a871a95&"
import script from "./AccUpdatePersonalData.vue?vue&type=script&lang=js&"
export * from "./AccUpdatePersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports